import { Input, inject, signal, WritableSignal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FormFieldTypeEnum } from '@shared/components/pm-form/models/enums/formFieldType.enum';
import { IFormFieldConfig } from '@shared/components/pm-form/models/formConfig.model';
import { Component } from '@angular/core';
import { GlobalProperties } from './GlobalProperties';
import { FormFieldDataService } from '@shared/components/pm-form/form-field-data.service';
import { catchError, Observable, tap } from 'rxjs';
import { IApiResponse } from '@shared/models/interfaces/IApiResponse';

import { v4 as uuidv4 } from 'uuid';
@Component({
  standalone: true,
  template: '',
  imports: [],
})
export abstract class FormFieldComponent extends GlobalProperties {
  private _uuid = uuidv4();
  formFieldDataService: FormFieldDataService;
  protected FormFieldTypeEnum = FormFieldTypeEnum;
  protected loading = signal(false);
  protected error: WritableSignal<null | string> = signal(null);
  @Input({ required: true }) formField!: IFormFieldConfig;
  @Input({ required: true }) ctrl!: FormControl;
  @Input() disabled? = false;
  @Input() hideError? = false;

  constructor() {
    super();
    this.formFieldDataService = inject(FormFieldDataService);
  }

  get ctrlUUID() {
    return (this.ctrl as any)?.uuid || this._uuid;
  }

  protected loadData(): Observable<
    IApiResponse<this['formField']['IApiResponseType']>
  > | null {
    if (!this.formField?.dataEndpoint) return null;

    this.loading.set(true);
    this.error.set(null);
    return this.formFieldDataService
      .getData<IApiResponse<this['formField']['IApiResponseType']>>(
        this.formField.dataEndpoint
      )
      .pipe(
        tap((response) => {
          this.formField.options = this.formField.mapper!(response);
          this.loading.set(false);
        }),
        catchError((err) => {
          console.error('FormFieldComponent loadData błąd');
          this.loading.set(false);
          this.error.set($localize`Wystąpił błąd`);
          throw err;
        })
      ) as this['formField']['IApiResponseType'];
  }
}
